module.exports = __webpack_public_path__ + "img/66.38f7b967.jpg";